'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _delete = require('./delete.svg');

var _delete2 = _interopRequireDefault(_delete);

var _ButtonBar = require('./ButtonBar');

var _ButtonBar2 = _interopRequireDefault(_ButtonBar);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // import './AddBlockMenu.css'


var AddBlockMenu = function (_React$Component) {
  (0, _inherits3.default)(AddBlockMenu, _React$Component);

  function AddBlockMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AddBlockMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddBlockMenu.__proto__ || (0, _getPrototypeOf2.default)(AddBlockMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AddBlockMenu, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          blocks = _props.blocks,
          onAdd = _props.onAdd,
          onDelete = _props.onDelete,
          _props$icon = _props.icon,
          icon = _props$icon === undefined ? '+' : _props$icon;
      var open = this.state.open;
      return _react2.default.createElement('div', {
        className: 'AddBlockMenu ' + (open ? 'open' : '')
      }, _react2.default.createElement(_ButtonBar2.default, {
        className: 'actual-menu'
      }, _react2.default.createElement('button', {
        className: 'toggler',
        onClick: function onClick(e) {
          _this2.setState({
            open: !open
          });
        }
      }, open ? 'X' : icon), _react2.default.createElement('div', {
        className: 'buttons'
      }, blocks.map(function (type, index) {
        return _react2.default.createElement('button', {
          key: index,
          onClick: function onClick() {
            onAdd(type);

            _this2.setState({
              open: false
            });
          }
        }, type.label || type);
      }), _react2.default.createElement('button', {
        className: 'delete',
        onClick: function onClick() {
          onDelete();

          _this2.setState({
            open: false
          });
        }
      }, _react2.default.createElement('img', {
        src: _delete2.default,
        alt: 'Delete'
      })))));
    }
  }]);
  return AddBlockMenu;
}(_react2.default.Component);

exports.default = AddBlockMenu;